<template>
    <div>
        <el-form ref="paymentForm" :model="requestForm.payment" label-position="top" label-width="120px">
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="Cadena de la dependencia"
                                  prop="chainDependence" :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 400, message: 'Este campo debería ser de máximo 400 caracteres', trigger: 'blur' }]">
                        <el-input v-my-only-alphanumeric="{maxChars: 400}"
                                  v-model="requestForm.payment.chainDependence">

                        </el-input>

                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Primer Apellido"
                                  prop="firstName" :rules="[{ required: false, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 100, message: 'Este campo debería ser de máximo 100 caracteres', trigger: 'blur' }]">
                        <el-input v-model="requestForm.payment.firstName"/>

                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Segundo Apellido"
                                  prop="secondName" :rules="[{ required: false, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 100, message: 'Este campo debería ser de máximo 100 caracteres', trigger: 'blur' }]">
                        <el-input v-model="requestForm.payment.secondName">

                        </el-input>

                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="Nombre(s)"
                                  prop="name" :rules="[{ required: false, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 100, message: 'Este campo debería ser de máximo 100 caracteres', trigger: 'blur' }]">
                        <el-input v-model="requestForm.payment.name">

                        </el-input>

                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Dominación o Razón Social"
                                  prop="denomination" :rules="[{ required: false, message: 'Este campo es obligatorio', trigger: 'blur' },
                                    { max: 400, message: 'Este campo debería ser de máximo 400 caracteres', trigger: 'blur' }]">
                        <el-input v-model="requestForm.payment.denomination">

                        </el-input>

                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Fecha de Presentación"
                                  prop="date"
                                  :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' }]">
                        <date-picker
                            v-if="!isAdmin"
                            :disabled-date="disabledDates"
                            format="DD-MM-YYYY"
                            type="range"
                            value-type="YYYY-MM-DD"
                            placeholder="Fecha de Presentación"
                            v-validate="'required'"
                            v-model="requestForm.payment.date"
                        ></date-picker>
                        <el-date-picker
                            v-if="showDate"
                            :picker-options="pickerOptions"
                            :editable="false"
                            v-model="requestForm.payment.date"
                            type="date"
                            placeholder="Selecciona una fecha"
                            style="width: 100%"
                            format="dd/MM/yyyy"
                            value-format="yyyy-MM-dd">
                        </el-date-picker>

                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="8">
                    <el-form-item label="Total efectivamente pagado"
                                  prop="total" :rules="[{ required: true, message: 'Este campo es obligatorio',
                                  trigger: 'blur' },
                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">
                        <el-input v-my-only-alphanumeric v-model="requestForm.payment.total">

                        </el-input>

                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Número de operación"
                                  prop="operationNumber" :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                    { max: 400, message: 'Este campo debería ser de máximo 400 caracteres', trigger: 'blur' },
                    {pattern:/^[ña-zÀ-úÑA-Z0-9 _]+?$/,message: 'Ingrese sólo letras y/o números'}]">
                        <el-input v-my-only-alphanumeric="{maxChars: 400}" v-model="requestForm.payment.operationNumber">

                        </el-input>

                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="Llave de pago"
                                  prop="paymentKey" :rules="[{ required: true, message: 'Este campo es obligatorio', trigger: 'blur' },
                    { max: 400, message: 'Este campo debería ser de máximo 400 caracteres', trigger: 'blur' },
                    {pattern:/^[ña-zÀ-úÑA-Z0-9_]+?$/,message: 'Ingrese sólo letras y/o números'}]">
                        <el-input v-my-only-alphanumeric="{maxChars: 400}" v-model="requestForm.payment.paymentKey">

                        </el-input>

                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <br>
        <el-row>
            <el-col>
                <el-button type="info"
                           @click="paymentValidate(1)">
                    Validar
                </el-button>
                <el-button type="primary"
                           @click="paymentValidate(2)">
                    Hoja de Ayuda
                </el-button>
            </el-col>
        </el-row>

        <el-dialog
            :visible.sync="showModalHelp"
            :close-on-press-escape="false"
            :close-on-click-modal="false">
            <span slot="title">
                <h5>Complete los campos</h5>
            </span>
            <el-form @submit.native.prevent ref="helpForm" :model="helpForm" label-width="120px"
                     label-position="top">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item label="Nombre"
                                      prop="name"
                                      :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-my-only-alphanumeric="{maxChars: 20}" v-model="helpForm.name"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Primer Apellido"
                                      prop="name"
                                      :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-my-only-alphanumeric="{maxChars: 20}" v-model="helpForm.firstName"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="Segundo Apellido"
                                      prop="name"
                                      :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-my-only-alphanumeric="{maxChars: 20}" v-model="helpForm.secondName"/>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="RFC"
                                      prop="rfc"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-my-only-alphanumeric="{maxChars: 20}" v-model="helpForm.rfc"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="CURP"
                                      prop="curp"
                                      :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-my-only-alphanumeric="{maxChars: 20}" v-model="helpForm.curp"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="Denominación o Razón Social"
                                      prop="denomination"
                                      :rules="{ required: false, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-input v-model="helpForm.denomination"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="Origen del pago"  prop="origin"
                                      :rules="{ required: true, message: 'Este campo es obligatorio', trigger: 'change' }">
                            <el-select
                                v-model="helpForm.origin"
                                style="width: 100%"
                                placeholder="Seleccionar">
                                <el-option
                                    v-for="item in origin"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
        <el-button
            class="btn btn-secondary"
            icon="fas fa-times"
            @click="showModalHelp=false">
            Cancelar
        </el-button>
        <el-button
            v-loading="showLoading"
            element-loading-text=""
            element-loading-spinner="el-icon-loading"
            class="btn btn-success"
            icon="fas fa-save"
            @click="makeSheetHelp()">
             Generar
        </el-button>
</span>
        </el-dialog>

    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import { Loading } from 'element-ui';
    export default {
        components: {
            DatePicker
        },

        props: {
            folio: {},
            procedure: {},
            model: {},
            isAdmin: {}
        },

        computed: {
            ...mapGetters('requests', {
                inboxForm: "inboxForm",
            }),

            ...mapGetters('utils', {
                requestForm: "requestForm",
                makeProcedure: "makeProcedure",
            }),

            userInfo() {
                return this.$store.state.user.user;
            },
        },

        watch:{
          'helpForm.origin'(value){
              if (value == 1) {
                  this.helpForm.chainDependence = '03' + this.folio;
              } else {
                  this.helpForm.chainDependence = '01' + this.folio;
              }
          }

        },

        data() {
            return {
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                showDate: true,
                showModalHelp: false,
                helpForm: {},
                showLoading: false,
                origin: [
                    {
                        id: 1,
                        name: 'CDMX'
                    },
                    {
                        id: 2,
                        name: 'Interior de la República'
                    }
                ]
            }
        },

        created() {
            if(this.$route && this.$route.path && this.$route.path.includes('/solicitudes')){
                this.showDate = false
            }
            this.requestForm.payment.chainDependence = null;
            this.requestForm.payment.firstName = null;
            this.requestForm.payment.secondName = null;
            this.requestForm.payment.name = null;
            this.requestForm.payment.denomination = null;
            this.requestForm.payment.date = null;
            this.requestForm.payment.total = null;
            this.requestForm.payment.operationNumber = null;
            this.requestForm.payment.paymentKey = null;
        },

        methods: {
            disabledDates(date) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);

                return date > today;
            },

            paymentValidate(type) {

                if (type == 1) {
                    this.$refs['paymentForm'].validate(valid => {
                        if (valid) {
                            let _params = {
                                ...this.requestForm.payment,
                                folio: this.folio
                            };
                            let loadingInstance = Loading.service({
                                lock: true,
                                text: 'Procesando información, espere...',
                                spinner: 'el-icon-loading',
                                background: 'rgba(0, 0, 0, 0.7)'
                            });
                            axios.post('/api/payment', _params).then(response => {
                               /*if (response.data.success) {
                                    this.inboxForm.inbox[this.model].payment = false;
                                    loadingInstance.close();
                                    this.$store.dispatch('notifications/ok', {msg: 'Pago validado correctamente'}, {root: true});
                                }else{
                                   this.inboxForm.inbox[this.model].payment = true;
                                   loadingInstance.close();
                                   this.$store.dispatch('notifications/error', {msg: response.data.message}, {root: true});
                               }*/
                                if (response.data.success[0] == "true") {
                                    this.inboxForm.inbox[this.model].payment = false;
                                    loadingInstance.close();
                                    this.$store.dispatch('notifications/ok', {msg: 'Pago validado correctamente'}, {root: true});
                                } else {
                                    this.requestForm.paymentIsValid = true;
                                    loadingInstance.close();
                                    this.$store.dispatch('notifications/error', {msg: 'Pago no validado, verifique la información'}, {root: true});
                                }
                            })

                        } else {
                            this.$store.dispatch('notifications/warning', {msg: 'Complete los campos requeridos'}, {root: true});
                        }
                    })
                } else if (type == 2) {
                    this.showModalHelp = true;
                }

            },

            makeHelp() {


            },

            makeSheetHelp() {
                this.$refs['helpForm'].validate().then(valid => {
                    if (valid) {
                        this.showLoading = true;

                        if (this.helpForm.origin == 1) {
                            this.helpForm.chainDependence = '03' + this.folio;
                        } else {
                            this.helpForm.chainDependence = '01' + this.folio;
                        }
                        let _params = {
                            ...this.helpForm,
                            cat_procedure_id: this.procedure
                        };

                        axios.post('/api/make-help-sheet', _params, {responseType: 'blob'})
                            .then(response => {
                                setTimeout(() => {
                                    this.$store.dispatch('notifications/ok', {msg: 'Generando Hoja de Ayuda...'}, {root: true});
                                }, 200);
                                this.showLoading = false;
                                const linkUrl = window.URL.createObjectURL(new Blob([response.data]));
                                const link = document.createElement('a');
                                link.href = linkUrl;
                                link.setAttribute('download', `Hoja de ayuda-${moment(new Date()).format('DD-MM-YYYY-HH:MM:SS')}-${this.userInfo.username}.pdf`);
                                document.body.appendChild(link);
                                link.click();
                                this.showLoading = false;
                                this.showModalHelp = false;
                                this.activateHelp = true;

                            })
                            .catch(error => {
                                console.log('error makeHelp', error);
                                this.showLoading = false;
                                this.$store.dispatch('notifications/error', {msg: 'No se pudo generar'}, {root: true});
                            });


                    } else {
                        this.showLoading = false;
                        this.$store.dispatch('notifications/warning', {msg: 'Complete los campos requeridos.'}, {root: true});
                    }
                })
            },

        },

        searchRepeat(){
            let array = [1,1,234,4,5,6,6,7,234];
            let repeats = [];
            let aux = null;

            for(let j = 0; j < repeats.length; j++){
                for(let i = 0; i < array.length; i++){
                    repeats.push(array[i]);
                }
            }



        }
    }
</script>

<style scoped>

</style>
